import React from 'react'

import { FastField, getIn } from 'formik'

import TimeInput from './TimeInput'

function timeframeToHours(start, end) {
	// expects start/end times as xx:xx 24 hour
	if(!start || !end) return 0;

	const startArr = start.split(':');
	const endArr = end.split(':');

	const hours = Number(endArr[0]) - Number(startArr[0]);
	const mins = Number(endArr[1]) - Number(startArr[1]);

	const minsDecimal = mins/60;

	return hours + minsDecimal;
}

		// const totalHours = values.reduce((acc, v) => {
			
		// 	return acc;
		// }, 0)

const days = {
	monday: 'Monday',
	tuesday: 'Tuesday',
	wednesday: 'Wednesday',
	thursday: 'Thursday',
	friday: 'Friday',
	saturday: 'Saturday',
	sunday: 'Sunday',
};

const TimeDisplay = ({ field }) => {
	return <div className="TimeDisplay">{field.value ? field.value : '-'}</div>
}

export default
class TimesheetLine extends React.Component {
	render() {
		const { field, form, isEditing } = this.props;

		const TimeComponent = isEditing ? TimeInput : TimeDisplay;
		// const totalHours = Object.
		// 
		const values = getIn(form.values, field.name);

		const totalHours = Object.keys(days).reduce((acc, day) => {
			const dayValues = values[day];
			const { start, end } = dayValues;
			if(start && end) {
				acc += timeframeToHours(start, end)
			}
			return acc;
		}, 0);
		

		return (
			<div className="TimesheetLine">
				<div className='TimesheetLine-shifts'>
					{
						Object.keys(days).map(key => {
							return (
								<div key={key} className={`TimesheetLine-day ${isEditing ? 'isEditing' : ''}`}>
									<div className="TimesheetLine-dayLabel">{days[key]}</div>
									<FastField name={`${field.name}.${key}.start`} component={TimeComponent} placeholder="from" />
									<FastField name={`${field.name}.${key}.end`} component={TimeComponent} placeholder="to" />
								</div>
							)
						})
					}
				</div>
				<div className="TimesheetLine-total">Total Hours: {totalHours}</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/modules/form/components/input/TimesheetLine.jsx